import { OAuthRedirect } from '../../OAuth/OAuthRedirect';
import { useUpdateOAuthState } from '../../OAuth/useUpdateOAuthState';

export const GustoOauthCallback = () => {
  const { isLoading, postError } = useUpdateOAuthState();

  return <OAuthRedirect isLoading={isLoading} error={postError} />;
};
